import React from 'react';
import { DesignSystemOverrides } from './design-system-overrides';
import { JspreadsheetOverrides } from './jspreadsheet-overrides';
import { ColorProperties } from './color-properties';
import { UtilityClasses } from './utility-classes';
import { Forms } from './forms';
import { Buttons } from './buttons';
import { Layout } from './layout';
import { Lists } from './lists';
import { Media } from './media';
import { Tables } from './tables';
import { Typography } from './typography';
import { MarginPadding } from './margin-padding';
export const GlobalStyles = () => (React.createElement(React.Fragment, null,
    React.createElement(ColorProperties, null),
    React.createElement(UtilityClasses, null),
    React.createElement(Buttons, null),
    React.createElement(Forms, null),
    React.createElement(Layout, null),
    React.createElement(Lists, null),
    React.createElement(Media, null),
    React.createElement(Tables, null),
    React.createElement(Typography, null),
    React.createElement(MarginPadding, null),
    React.createElement(DesignSystemOverrides, null),
    React.createElement(JspreadsheetOverrides, null)));
//# sourceMappingURL=index.js.map